import { find, reduce } from "lodash";

import batchUtils from "../modules/batchUtils";
import { tutorialSelectors } from "../modules/tutorial";
import { tutorialGroupById, tutorialResolutionById } from "../tutorial";
import getActionForResolvedTips from "../tutorial/getActionForResolvedTips";

/**
 *
 * @param {function} t (testFunction)
 * @param {object} b (batchAction)
 * @param {TimelineRecord} n (newState)
 * @param {TimelineRecord} o (oldState)
 * @returns
 */
export const testBatch = (t, b, n, o) => find(batchUtils.nestedActionsInBatch(b), a => t(a, n, o));

export default store => next => action => {
  const prevState = store.getState();
  const prevPresentState = prevState.present;

  let result = next(action);

  const nextState = store.getState();
  const nextPresentState = nextState.present;

  if (nextPresentState.activeTutorialPath) {
    const completedSet = tutorialSelectors.getCompletedTips(nextPresentState);
    const activeTutorial = tutorialSelectors.getActiveTutorial(nextPresentState);

    let resolved = [];
    if (activeTutorial) {
      resolved = reduce(
        tutorialResolutionById,
        (result, resolve, id) => {
          if (
            tutorialGroupById[id] === activeTutorial &&
            !completedSet.has(id) &&
            testBatch(resolve, action, nextPresentState, prevPresentState)
          ) {
            result.push(id);
          }
          return result;
        },
        []
      );
    }

    if (resolved.length) {
      const fallbackBrowserAction = getActionForResolvedTips(resolved, activeTutorial, completedSet);
      if (fallbackBrowserAction) {
        store.dispatch(fallbackBrowserAction);
      }
    }
  }

  return result;
};
